import React from 'react';
import { Check, X, ArrowRight, Sparkles } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import SavingsCalculator from './SavingsCalculator';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const rows = [
  { label: 'Preis', hireka: '7.999 € Festpreis', trad: '20.000–35.000 € (20–35 % vom Gehalt)' },
  { label: 'Erster Kandidat', hireka: 'in 24 Stunden', trad: 'nach 4–12 Wochen' },
  { label: 'Kandidaten', hireka: 'interviewt & gebrieft', trad: 'CV weitergeleitet' },
  { label: 'Nachbesetzung', hireka: 'kostenlos', trad: 'erneut zahlen' },
  { label: 'Ansprechpartner', hireka: 'persönlich, immer erreichbar', trad: 'wechselnd' },
];

const PricingSection = () => (
  <section id="premium-plus" className="relative bg-white py-24 lg:py-32 overflow-hidden" data-testid="pricing-section">
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full bg-violet-100/50 blur-[140px] pointer-events-none" />
    <div className="relative max-w-6xl mx-auto px-5 lg:px-8">
      <SectionHeading
        eyebrow="Premium Plus · Preis"
        title={<>Ein Preis. <span className="text-violet-gradient">Keine Prozente.</span> Keine Überraschungen.</>}
        subtitle="Egal ob Sachbearbeiter oder CFO: Du zahlst immer denselben Festpreis. Vergleich das einmal mit deiner letzten Vermittler-Rechnung."
      />

      <div className="mt-16 grid lg:grid-cols-12 gap-6 items-stretch">
        <Reveal className="lg:col-span-5 lux-card p-8 flex flex-col" data-testid="pricing-card-traditional">
          <p className="eyebrow text-slate-400"><span className="eyebrow-line" />Klassischer Vermittler</p>
          <div className="mt-6 font-display text-3xl sm:text-4xl font-extrabold text-slate-400 line-through decoration-rose-400/70 decoration-4 whitespace-nowrap">20.000–35.000 €</div>
          <p className="mt-2 text-slate-500 text-sm">20–35 % vom Jahresgehalt · pro Position</p>
          <ul className="mt-8 space-y-4 flex-1">
            {rows.map((r, i) => (
              <li key={i} className="flex items-start gap-3 text-sm">
                <X className="w-4 h-4 text-rose-400 mt-0.5 shrink-0" />
                <span className="text-slate-500"><span className="text-slate-400 font-medium">{r.label}: </span>{r.trad}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-7 relative" data-testid="pricing-card-hireka">
          <div className="absolute -inset-1 bg-gradient-to-br from-amber-400/40 via-violet-500/40 to-amber-400/40 rounded-[1.6rem] blur-lg opacity-70" />
          <div className="relative lux-card-dark p-8 lg:p-10 h-full flex flex-col text-white overflow-hidden">
            <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-violet-600/30 blur-3xl" />
            <div className="relative flex items-center justify-between flex-wrap gap-3">
              <p className="eyebrow text-amber-300"><span className="eyebrow-line" />HIREKA Premium Plus</p>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-400 text-obsidian text-xs font-bold px-3 py-1"><Sparkles className="w-3.5 h-3.5" /> Spare bis zu 75 %</span>
            </div>
            <div className="relative mt-6 flex items-end gap-3 flex-wrap">
              <div className="font-display text-6xl lg:text-7xl font-extrabold text-gold leading-none">7.999 €</div>
              <p className="text-slate-400 text-sm pb-2">Festpreis · zzgl. MwSt.<br />jede Position, jedes Gehalt</p>
            </div>
            <ul className="relative mt-8 space-y-4 flex-1">
              {rows.map((r, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center shrink-0 mt-0.5"><Check className="w-3.5 h-3.5 text-emerald-400" /></span>
                  <span className="text-slate-200"><span className="text-slate-400">{r.label}: </span><span className="font-semibold text-white">{r.hireka}</span></span>
                </li>
              ))}
            </ul>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-gold mt-10 w-full px-6 py-4 text-base text-center" data-testid="pricing-cta-btn">
              {CTA_LABEL} <ArrowRight className="w-5 h-5" />
            </a>
            <p className="mt-4 text-center text-xs text-slate-500">100 % kostenlos · Unverbindlich · 30 Minuten</p>
          </div>
        </Reveal>
      </div>

      <SavingsCalculator />
    </div>
  </section>
);

export default PricingSection;
